var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/message-detail.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-36dc4b2a!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/message-detail.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MessageDetail.vue
// module id = 1309
// module chunks = 1